import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-grade-project-mgr",
  "use": "icon-grade-project-mgr-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-grade-project-mgr\"><path d=\"M108.348548 99.850622v824.298756l412.149377-127.46888 412.149378 127.46888V99.850622H108.348548z m384.53112 522.622407h-176.33195V344.165975H384.53112v223.07054h108.348548v55.236514z m165.709544 0h-80.730291l-82.854772-278.307054h70.107884l31.86722 127.46888c8.497925 29.742739 12.746888 59.485477 21.244813 89.228216h2.124482c8.497925-29.742739 14.871369-59.485477 21.244813-89.228216l31.86722-127.46888h67.983402l-82.854771 278.307054z\" p-id=\"2444\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/grade-project-mgr.svg
// module id = lNXS
// module chunks = 115